<template>
  <el-dialog
    :key="formKey"
    v-dialogDrag
    :title="$t('user.synchroUser')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    custom-class="self-dialog-form"
    width="1000px"
  >
    <!-- 搜索框 -->
    <search-currency
      :search-query-param="searchQueryParam"
      @search="handleSearch"
      @reset="handleSearch"
    />
    <!-- /搜索框 -->
    <!-- 表格操作按钮 -->
    <!-- 表格 -->
    <EdmCustomTable
      ref="EdmCustomTable"
      :loading="tableLoading"
      :table-data="tableData"
      :pagination="pagination"
      :checkbox="true"
      row-key="username"
      :reserve-selection="true"
      @handleSizeChange="handlePaginationChange"
      @handleCurrentChange="handlePaginationChange"
    >
      <el-table-column
        v-for="(cm, index) in tableColumns"
        :key="cm.field"
        :label="cm.name"
        :index="index"
        :width="cm.width"
        :fixed="cm.fixed"
        :min-width="100"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{ scope.row[cm.field] }}
        </template>
      </el-table-column>
    </EdmCustomTable>
    <!-- /表格 -->
    <span slot="footer" class="dialog-footer">
      <el-button plain @click="dialogVisible = false">
        {{ $t('public.cancel') }}
      </el-button>
      <el-button type="primary" @click="synchro">
        {{ $t('public.confirm') }}
      </el-button>
    </span>
    <delete-dialog
      layout="left"
      :visible.sync="synchroTipVisible"
      :content="synchroTipLoadingContent"
      :loading.sync="synchroTipLoading"
      @confirm="handleDeleteConfirm"
    />
  </el-dialog>
</template>

<script>
import SearchCurrency from "@/components/private/search-currency";
import userApi from "@/api/user/user";
import { mapGetters } from "vuex";
import DeleteDialog from "@/components/common/Dialogs/DeleteDialog";
export default {
  name: "SynchroUser",
  components: {
    SearchCurrency,
    DeleteDialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    propData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      formKey: new Date().getTime(),
      tableLoading: false,
      tableColumns: [
        {
          name: this.$t("userCenter.name"),
          field: "displayName",
          width: "100",
          fixed: false
        },
        {
          name: this.$t("public.username"),
          field: "username",
          width: "200",
          fixed: false
        },
        {
          name: this.$t("user.belongOrg"),
          field: "groupName",
          width: "200",
          fixed: false
        },
        {
          name: this.$t("user.sex"),
          field: "sexValue",
          width: "100",
          fixed: false
        },
        {
          name: this.$t("user.stateValue"),
          field: "stateValue",
          width: "auto",
          fixed: false
        },
        {
          name: this.$t("user.updateDate"),
          field: "updateTime",
          width: "200",
          fixed: false
        }
      ],
      tableData: [],
      pagination: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      searchForm: {},
      searchQueryParam: [
        {
          hidden: false,
          moreFlag: false,
          searchItemName: "orgId",
          searchItemBindingFlag: "orgId",
          searchItemDisplayName: "HR组织",
          searchItemType: 5,
          searchItemDataService: "/admin",
          searchItemDataUrl: "/api/v1/third-party/org/tree",
          searchItemDataRequestMethod: "get",
          searchItemDataLabel: "orgName",
          searchItemDataValue: "id",
          searchItemDataChildren: "",
          searchItemDataMultiple: false
        },
        {
          hidden: false,
          moreFlag: false,
          searchItemName: "username",
          searchItemBindingFlag: "username",
          searchItemDisplayName: "HR用户名",
          searchItemType: 1
        },
        {
          hidden: false,
          moreFlag: false,
          searchItemName: "displayName",
          searchItemBindingFlag: "displayName",
          searchItemDisplayName: "HR姓名",
          searchItemType: 1
        }
      ],
      synchroTipVisible: false,
      synchroTipLoading: false,
      synchroTipLoadingContent: {
        title: "提示信息",
        description: `您确定将已选择的HR系统用户同步到【${this.propData.orgName}】部门下吗？`
      }
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },
    ...mapGetters(["tenantId"])
  },
  created() {
    this.getList();
  },
  methods: {
    handleDeleteConfirm() {
      const checkedArr = this.$refs.EdmCustomTable.getChecked();
      this.synchroTipLoading = true;
      userApi.synchroThirdPartyUser(checkedArr, this.propData.id).then(
        res => {
          this.synchroTipLoading = false;
          if (res.success) {
            this.synchroResultObj = res.data;
            this.synchroTipVisible = false;
            this.dialogVisible = false;
            this.$message.success("同步成功!");
            this.$emit("confirm", res.data);
          }
        },
        () => {
          this.synchroTipLoading = false;
        }
      );
    },
    // 遍历树结构
    traverseTree(data) {
      data.forEach(val => {
        val.label = val.orgName;
        val.value = val.id;
        if (val.children) {
          this.traverseTree(val.children);
        }
      });
      return data;
    },
    // 获取组织列表数据
    getList() {
      const params = {
        page: this.pagination.pageNum,
        size: this.pagination.pageSize
      };
      for (const key in this.searchForm) {
        params[key] = this.searchForm[key];
      }
      this.tableLoading = true;
      userApi.getThirdPartyUser(params).then(
        res => {
          this.tableLoading = false;
          const { data } = res;
          if (res.success) {
            const { records = [], total = 0 } = data;
            this.tableData = records;
            this.pagination.total = Number(total);
          }
        },
        () => {
          this.tableLoading = false;
        }
      );
    },
    handleSearch(data) {
      this.searchForm = data;
      this.pagination.pageNum = 1;
      this.getList();
    },
    // 条数改变|页数改变
    handlePaginationChange(data) {
      this.$set(this, "pagination", data);
      this.getList();
    },
    synchro() {
      // 获取选中的数据
      const checkedArr = this.$refs.EdmCustomTable.getChecked();
      if (checkedArr.length === 0) {
        this.$message.warning("请选择要同步的用户");
        return;
      }
      this.synchroTipVisible = true;
    }
  }
};
</script>

<style scoped lang="scss">
.synchro-org {
  float: left;
  line-height: 32px;
}
::v-deep .self-dialog-form {
  .el-dialog__body {
    max-height: 100% !important;
    overflow-y: hidden !important;
  }
}
.btn-wrap {
  padding: 8px 0;
}
.mr16 {
  margin-right: 16px;
}
</style>
